<template>
  <!-- 工业园平台操作后台 -->
  <div class="chome">
    <c-header></c-header>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<style lang="scss" scope>
.chome {
  width: 100%;
  height: 100%;
  .content {
    width: 100%;
    height: calc(100% - 7em);
    background-color: #eee;
    overflow: auto;
  }
}
</style>

<script>
const header = () => import("../components/header");

export default {
  data() {
    return {};
  },
  components: {
    "c-header": header
  },
  // beforeRouteUpdate(to, from, next) {
    // if(to.name == "map" && from.name == "map") {
    //   window.location.reload()
    // }
    // next()
  // },
  methods: {}
};
</script>